<script setup lang="ts">
  import type { SeparatorProps } from 'reka-ui'
  import type { HTMLAttributes } from 'vue'
  import { reactiveOmit } from '@vueuse/core'
  import { cn } from '../../../lib/utils'
  import { Separator } from '../separator'

  // Re-inline `DataOrientation` locally to avoid the TS2883 `__VLS_export`
  // inference leak under TS 6 — reka-ui keeps the type in `dist/index3`
  // without a top-level re-export, so the generated component export can't
  // name it portably. (Mirrors `ui/separator/Separator.vue`.)
  type Orientation = 'vertical' | 'horizontal'
  type Props = Omit<SeparatorProps, 'orientation'> & {
    orientation?: Orientation
    class?: HTMLAttributes['class']
  }

  const props = withDefaults(defineProps<Props>(), {
    orientation: 'vertical'
  })
  const delegatedProps = reactiveOmit(props, 'class')
</script>

<template>
  <Separator
    data-slot="button-group-separator"
    v-bind="delegatedProps"
    :orientation="props.orientation"
    :class="
      cn(
        'bg-input relative !m-0 self-stretch data-[orientation=vertical]:h-auto',
        props.class
      )
    "
  />
</template>
